module.exports = __webpack_public_path__ + "img/ico_modal_warning.f08cec83.svg";